// extracted by mini-css-extract-plugin
module.exports = {"name":"profile_name__RoiMb","email":"profile_email__2LTYA","headertext":"profile_headertext__LaLI5","subtext":"profile_subtext__2xT01"};